import React from 'react'
import { X } from 'react-feather'

import './index.scss'

/** 
* @param {Boolean} show
* @param {String} title
* @param {Boolean} showHeader
*/
function Modal({ show = false, showHeader = true, onClose, title, modalWidth = 452, children, renderFooter, backdropColor }) {

  const handleCloseModal = () => onClose && onClose()

  return (
    <div className={show ? "modal modal--visible" : "modal"} style={{ backgroundColor: backdropColor }}>
      <section className={show ? "modal__container modal__container--visible" : "modal__container"} style={{ maxWidth: modalWidth }}>
        {showHeader &&
          <header className="modal__container__header">
            <div className="modal__container__title">
              {title && <h1>{title}</h1>}
            </div>
            {onClose && <X className="modal__container__close" size={30} onClick={handleCloseModal} />}
          </header>
        }

        <main className="modal__container__main">
          {children}
        </main>

        {renderFooter &&
          <footer className="modal__container__footer">
            {renderFooter}
          </footer>
        }
      </section>
    </div>
  )
}

export default Modal
